import React from 'react';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import { mainContentPadding } from '../../../../../v2BaseComponents/MainContentContainer';
import useOrganizationUserUsers from '../../../../../../hooks/api/useOrganizationUsers';
import OrganizationUsersTable from './OrganizationUsersTable';
import { View } from 'react-native';
import { useIsMobileLayout } from '../../../../../../hooks/useIsMobileLayout';

export type OrganizationUsersTabOwnProps = {};

export type OrganizationUsersTabProps = OrganizationUsersTabOwnProps;

const OrganizationUsersTab: React.FC<OrganizationUsersTabProps> = () => {
    const { isLoadingUsers } = useOrganizationUserUsers({});
    const isMobile = useIsMobileLayout();
    return (
        <AnimateLoadedContent isLoading={isLoadingUsers}>
            {() => (
                <>
                    <View
                        style={{ width: '100%', height: '100%', paddingTop: isMobile ? undefined : mainContentPadding }}
                    >
                        <OrganizationUsersTable />
                    </View>
                </>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(OrganizationUsersTab);
